import axios from "axios";

const apiClient = axios.create({
  baseURL: "https://crm.hubsyntax.com/api", 
  withCredentials: true,    
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("auth_user");
    }
    return Promise.reject(error);
  }
);

export default apiClient;
